let baseState = () => {
  return {
    componentList: [],
    newComponent: {
      name: '',
      type: 'Component',
      language: null,
      language_id: null,
      json: {
        baseComponent: '',
        path: '',
        components: [],
        config: {}
      },
      config: {}
    }
  }
}

const state = baseState()

export default state
export { baseState }
